export enum EmitterEvent {
  CLOSE = 'close',
  CLOSE_ALL = 'closeAll',
}
